import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=36190e2e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=36190e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36190e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36190e2e')) {
      api.createRecord('36190e2e', component.options)
    } else {
      api.reload('36190e2e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=36190e2e&scoped=true&", function () {
      api.rerender('36190e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8Hs3GBpdX8j/JS/comp/PopupDialog.vue"
export default component.exports